import lodash from 'lodash';
import api from '../../modules/App/socket';
import { USER_STATUS_ACTIVE } from '../constants';

export const getUsers = (params = {}) => {
    const defaultParams = {
        searchByName: lodash.get(params, 'searchByName'),
        attributes: ['person.first_name', 'person.last_name'],
        groups: {
            $in: lodash.isArray(lodash.get(params, 'groups')) ? lodash.get(params, 'groups') : [],
        },
    };

    const filters = {
        ref_user_status: USER_STATUS_ACTIVE,
        groups: defaultParams.groups,
    };

    if (defaultParams.searchByName) {
        filters.$or = [
            {
                'person.first_name': {
                    $regex: defaultParams.searchByName,
                    $options: 'i',
                },
            },
            {
                'person.last_name': {
                    $regex: defaultParams.searchByName,
                    $options: 'i',
                },
            },
        ];
    }

    return api.send({
        api: 'db',
        model: 'User',
        action: 'Read',
        options: {
            limit: 10,
            attributes: defaultParams.attributes,
            where: filters,
        },
    }).then((res) => res).catch((res) => res);
};



// WEBPACK FOOTER //
// ./src/common/requests/users.js